import { Button } from '@/components/button';

import { toCapitalize } from '@/helpers/string';

import './item.css';

const TIMEZONE = 'Europe/Paris';

const monthFormatter = new Intl.DateTimeFormat('fr-FR', {
  month: 'short',
  timeZone: TIMEZONE,
});

const dayFormatter = new Intl.DateTimeFormat('fr-FR', {
  day: 'numeric',
  timeZone: TIMEZONE,
});

const detailsFormatter = new Intl.DateTimeFormat('fr-FR', {
  hour: '2-digit',
  minute: '2-digit',
  day: '2-digit',
  month: 'long',
  year: 'numeric',
  hourCycle: 'h23',
  timeZone: TIMEZONE,
});

const formatDetails = (date) => {
  const parts = detailsFormatter.formatToParts(date).reduce((acc, part) => {
    acc[part.type] = part.value;

    return acc;
  }, {});

  return `${parts.hour}:${parts.minute} - ${parts.day} ${parts.month} ${parts.year}`;
};

/**
 * @param {object} props
 * @param {import('@/helpers/server/circle').CircleEvent} props.event
 */
export const CalendarItem = ({ event }) => {
  const date = new Date(event.startsAt);
  const month = toCapitalize(monthFormatter.format(date).replace(/\.$/, ''));

  return (
    <div className="calendar__item">
      <div className="calendar__item__date">
        <b>{month}</b>
        <div>{dayFormatter.format(date)}</div>
      </div>

      <div className="calendar__item__wrap">
        <div>
          <p className="calendar__item__title">{event.title}</p>

          {event.description ? (
            <p className="calendar__item__description">{event.description}</p>
          ) : null}
        </div>

        <div>
          <p className="calendar__item__details">{formatDetails(date)}</p>

          {event.hostAvatarUrl ? (
            <div className="calendar__item__avatars">
              {/* Circle assets aren't on Storyblok — the custom next/image loader can't serve them */}
              <img src={event.hostAvatarUrl} alt={event.hostName || ''} />
            </div>
          ) : null}
        </div>
      </div>

      <div className="calendar__item__cta">
        <Button
          link={{ linktype: 'url', url: event.url, cached_url: event.url }}
          theme="full-black"
        >
          S&apos;inscrire
        </Button>
      </div>
    </div>
  );
};
